/* ===========================================
   KS B2B MEGAMENU — toiminnallisuus
   ===========================================
   Lukee valikkopuun #ksb2b-data-JSONista ja rakentaa:
   - työpöydän KAUPPA-megapaneelin (osastoraide + sarakkeet + nostokortti)
   - mobiilihaitarin teeman draweriin ([data-ksb2b-mobile])
   Paneeli asemoidaan fixed-asemointiin navipalkin alle, jotta se
   toimii teeman sticky-headerin kanssa. */
(function () {
  'use strict';

  var dataEl = document.getElementById('ksb2b-data');
  if (!dataEl || window.__ksb2bInit) return;
  window.__ksb2bInit = true;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('KS B2B megamenu: data ei jäsenny', e);
    return;
  }

  var KAUPPA = DATA.kauppa || [];
  var TOPNAV = DATA.topnav || [];

  /* ---------- apurit ---------- */
  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html != null) node.innerHTML = html;
    return node;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function badge(tag) {
    if (!tag) return '';
    var cls = tag === 'NEW' ? ' is-new' : tag === 'SUOMI' ? ' is-suomi' : tag === 'B2B' ? ' is-b2b' : '';
    return '<span class="ksb2b-badge' + cls + '">' + esc(tag) + '</span>';
  }
  var CHEV = '<svg class="ksb2b-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
  var CHEV_D = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';

  /* ===========================================
     TYÖPÖYTÄ — megapaneeli
     =========================================== */
  function initDesktop() {
    var trigger = document.querySelector('[data-ksb2b-mega-trigger]');
    if (!trigger) return;

    var backdrop = el('div', 'ksb2b-backdrop');
    var mega = el('div', 'ksb2b-mega');
    var inner = el('div', 'ksb2b-mega-inner');
    mega.appendChild(inner);
    document.body.appendChild(backdrop);
    document.body.appendChild(mega);

    var rail = el('nav', 'ksb2b-rail');
    var content = el('div', 'ksb2b-content');
    var aside = el('aside', 'ksb2b-aside');
    inner.appendChild(rail);
    inner.appendChild(content);
    inner.appendChild(aside);

    var active = 0;
    var railItems = [];

    KAUPPA.forEach(function (cat, i) {
      var a = el('a', 'ksb2b-rail-item' + (cat.accent ? ' is-accent' : ''),
        '<span>' + esc(cat.l) + '</span>' + CHEV);
      a.href = cat.h;
      a.addEventListener('mouseenter', function () { setActive(i); });
      rail.appendChild(a);
      railItems.push(a);
    });

    function setActive(i) {
      if (active === i && content.childNodes.length) return;
      active = i;
      railItems.forEach(function (item, j) {
        item.classList.toggle('is-active', j === i);
      });
      renderContent(KAUPPA[i]);
      renderAside(KAUPPA[i]);
    }

    function renderContent(cat) {
      content.innerHTML = '';
      var head = el('div', 'ksb2b-head',
        '<h3>' + esc(cat.l) + '</h3><a href="' + esc(cat.h) + '" class="ksb2b-seeall">Katso koko osasto →</a>');
      content.appendChild(head);

      if (cat.c && cat.c.length) {
        var cols = el('div', 'ksb2b-cols');
        /* kiinteä sarakejako: ryhmät jaetaan järjestyksessä kolmeen palstaan,
           jolloin tason 3 avaus ei siirrä muita ryhmiä toiseen sarakkeeseen */
        var colCount = 3;
        var perCol = Math.ceil(cat.c.length / colCount);
        var colEls = [];
        for (var ci = 0; ci < colCount; ci++) {
          colEls.push(el('div', 'ksb2b-col'));
          cols.appendChild(colEls[ci]);
        }
        var hoverTimer = null;
        cat.c.forEach(function (sub, j) {
          var group = el('div', 'ksb2b-group');
          var hasKids = sub.c && sub.c.length;
          var link = el('a', 'ksb2b-l2',
            esc(sub.l) + badge(sub.tag) + (hasKids ? '<span class="ksb2b-plus">+</span>' : ''));
          link.href = sub.h;
          group.appendChild(link);

          if (hasKids) {
            var wrap = el('div', 'ksb2b-l3wrap');
            var innerL3 = el('div', 'ksb2b-l3inner');
            sub.c.forEach(function (t) {
              var l3 = el('a', 'ksb2b-l3link', esc(t.l) + badge(t.tag));
              l3.href = t.h;
              innerL3.appendChild(l3);
            });
            wrap.appendChild(innerL3);
            group.appendChild(wrap);

            var openL3 = function () {
              cols.querySelectorAll('.ksb2b-l3wrap.is-show').forEach(function (w) {
                if (w !== wrap) {
                  w.classList.remove('is-show');
                  var p = w.parentNode.querySelector('.ksb2b-plus');
                  if (p) p.textContent = '+';
                }
              });
              wrap.classList.add('is-show');
              link.querySelector('.ksb2b-plus').textContent = '–';
            };
            /* pieni viive, ettei ohi kulkeva kursori availe listoja turhaan */
            group.addEventListener('mouseenter', function () {
              clearTimeout(hoverTimer);
              hoverTimer = setTimeout(openL3, 130);
            });
            group.addEventListener('mouseleave', function () {
              clearTimeout(hoverTimer);
            });
            link.querySelector('.ksb2b-plus').addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              clearTimeout(hoverTimer);
              if (wrap.classList.contains('is-show')) {
                wrap.classList.remove('is-show');
                link.querySelector('.ksb2b-plus').textContent = '+';
              } else {
                openL3();
              }
            });
          }
          colEls[Math.min(Math.floor(j / perCol), colCount - 1)].appendChild(group);
        });
        content.appendChild(cols);
      } else {
        content.appendChild(el('div', 'ksb2b-empty',
          'Selaa koko <a href="' + esc(cat.h) + '">' + esc(cat.l) + '</a>‑osastoa →'));
      }
    }

    function renderAside(cat) {
      aside.innerHTML = '';
      var nosto = el('a', 'ksb2b-nosto');
      nosto.href = cat.h;
      var img = el('div', 'ksb2b-nosto-img',
        (cat.i ? '' : '<span class="ksb2b-nosto-fallback">' + esc(cat.l) + '</span>') +
        '<span class="ksb2b-nosto-eyebrow">Esillä nyt</span>');
      if (cat.i) img.style.backgroundImage = 'url(' + cat.i + ')';
      nosto.appendChild(img);
      nosto.appendChild(el('div', 'ksb2b-nosto-body',
        '<span class="ksb2b-nosto-title">' + esc(cat.l) + '</span>' +
        '<span class="ksb2b-nosto-blurb">' + esc(cat.b || '') + '</span>' +
        '<span class="ksb2b-nosto-cta">Katso kaikki →</span>'));
      aside.appendChild(nosto);

      var outlet = el('a', 'ksb2b-outlet',
        '<span class="ksb2b-outlet-tag">OUTLET</span><span>Löytöjä ja poistuvia eriä</span>');
      outlet.href = '/collections/outlet';
      aside.appendChild(outlet);
    }

    /* asemointi navipalkin alle (sticky-header huomioiden) */
    function position() {
      var nav = trigger.closest('.ks-nav') || trigger.closest('.header__menu') || trigger;
      var rect = nav.getBoundingClientRect();
      var top = Math.max(0, Math.round(rect.bottom));
      mega.style.top = top + 'px';
      mega.style.maxHeight = 'calc(100vh - ' + top + 'px)';
      backdrop.style.top = top + 'px';
    }

    var isOpen = false;
    var closeTimer = null;

    function openNow() {
      clearTimeout(closeTimer);
      if (!isOpen) {
        isOpen = true;
        setActive(active);
        position();
        mega.classList.add('is-open');
        backdrop.classList.add('is-open');
        trigger.classList.add('is-open');
      } else {
        position();
      }
    }
    function closeSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeNow, 140);
    }
    function closeNow() {
      clearTimeout(closeTimer);
      isOpen = false;
      mega.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      trigger.classList.remove('is-open');
    }

    trigger.addEventListener('mouseenter', openNow);
    trigger.addEventListener('mouseleave', closeSoon);
    mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    mega.addEventListener('mouseleave', closeSoon);
    backdrop.addEventListener('mouseenter', closeSoon);
    backdrop.addEventListener('click', closeNow);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNow();
    });
    window.addEventListener('scroll', function () { if (isOpen) position(); }, { passive: true });
    window.addEventListener('resize', function () { if (isOpen) position(); });

    /* klikkaus avaa/sulkee myös (kosketusnäytöt) */
    var topLink = trigger.querySelector('.ksb2b-toplink');
    if (topLink) {
      topLink.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          if (isOpen) { closeNow(); } else { openNow(); }
        }
      });
    }
  }

  /* ===========================================
     MOBIILI — haitari draweriin
     =========================================== */
  function initMobile() {
    var host = document.querySelector('[data-ksb2b-mobile]');
    if (!host) return;

    function collapse(showCls) {
      return el('div', 'ksb2b-m-collapse' + (showCls || ''));
    }
    function toggleRow(row, wrap) {
      var open = row.classList.toggle('is-open');
      wrap.classList.toggle('is-show', open);
    }

    var acc = el('div', 'ksb2b-m-acc');

    KAUPPA.forEach(function (cat) {
      var catBox = el('div', 'ksb2b-m-cat');
      var hasKids = cat.c && cat.c.length;

      if (!hasKids) {
        /* suora linkki (Tiluksilla, OUTLET) */
        var rowLink = el('a', 'ksb2b-m-row' + (cat.accent ? ' is-accent' : ''),
          '<span>' + esc(cat.l) + '</span><span class="ksb2b-m-chev">' + CHEV_R + '</span>');
        rowLink.href = cat.h;
        catBox.appendChild(rowLink);
        acc.appendChild(catBox);
        return;
      }

      var row = el('button', 'ksb2b-m-row' + (cat.accent ? ' is-accent' : ''),
        '<span>' + esc(cat.l) + '</span><span class="ksb2b-m-chev">' + CHEV_D + '</span>');
      row.type = 'button';
      var wrap = collapse();
      var wrapIn = el('div');

      var all = el('a', 'ksb2b-m-all', 'Katso koko osasto →');
      all.href = cat.h;
      wrapIn.appendChild(all);

      cat.c.forEach(function (sub) {
        var subBox = el('div', 'ksb2b-m-sub');
        var subKids = sub.c && sub.c.length;

        if (!subKids) {
          var subLink = el('a', 'ksb2b-m-subrow',
            '<span class="ksb2b-m-l2">' + esc(sub.l) + badge(sub.tag) + '</span>');
          subLink.href = sub.h;
          subBox.appendChild(subLink);
        } else {
          var subRow = el('button', 'ksb2b-m-subrow',
            '<span class="ksb2b-m-l2">' + esc(sub.l) + badge(sub.tag) + '</span>' +
            '<span class="ksb2b-m-chev is-sm">' + CHEV_D + '</span>');
          subRow.type = 'button';
          var subWrap = collapse();
          var l3 = el('div', 'ksb2b-m-l3');

          var allSub = el('a', 'ksb2b-m-l3link', '<b>Kaikki: ' + esc(sub.l) + ' →</b>');
          allSub.href = sub.h;
          l3.appendChild(allSub);

          sub.c.forEach(function (t) {
            var l3link = el('a', 'ksb2b-m-l3link', esc(t.l) + badge(t.tag));
            l3link.href = t.h;
            l3.appendChild(l3link);
          });
          subWrap.appendChild(l3);
          subRow.addEventListener('click', function () { toggleRow(subRow, subWrap); });
          subBox.appendChild(subRow);
          subBox.appendChild(subWrap);
        }
        wrapIn.appendChild(subBox);
      });

      wrap.appendChild(wrapIn);
      row.addEventListener('click', function () { toggleRow(row, wrap); });
      catBox.appendChild(row);
      catBox.appendChild(wrap);
      acc.appendChild(catBox);
    });

    host.appendChild(acc);

    /* muut ylätason kohdat listan loppuun */
    var foot = el('div', 'ksb2b-m-foot');
    TOPNAV.forEach(function (item) {
      if (item.mega) return;
      var a = el('a', null, esc(item.l));
      a.href = item.h;
      foot.appendChild(a);
      (item.sub || []).forEach(function (s) {
        var sa = el('a', null, '&nbsp;&nbsp;&nbsp;' + esc(s.l));
        sa.href = s.h;
        sa.style.fontWeight = '300';
        sa.style.letterSpacing = 'normal';
        foot.appendChild(sa);
      });
    });
    host.appendChild(foot);
  }

  /* ===========================================
     PIKKUDROPDOWNIT (MEISTÄ / YHTEISTYÖTÄ?)
     ===========================================
     JS-ohjattu avaus/sulku viiveellä, ettei valikko välähdä kiinni
     kun kursori käy hetkellisesti valikon reunan ulkopuolella. */
  function initSmallDrops() {
    document.querySelectorAll('.ksb2b-item').forEach(function (item) {
      var drop = item.querySelector('.ksb2b-drop');
      if (!drop) return;
      var timer = null;
      function open() {
        clearTimeout(timer);
        item.classList.add('is-open');
      }
      function closeSoon() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          item.classList.remove('is-open');
        }, 180);
      }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', closeSoon);
      drop.addEventListener('mouseenter', open);
      drop.addEventListener('mouseleave', closeSoon);
    });
  }

  /* ===========================================
     LIVE-HAKU (Shopify predictive search)
     ===========================================
     Hakee tuotteita /search/suggest.json-rajapinnasta sitä mukaa
     kun käyttäjä kirjoittaa, ja näyttää ne paneelissa kentän alla.
     Enter vie normaalille hakusivulle (lomake submitoituu). */
  function initSearch() {
    document.querySelectorAll('[data-ks-search-wrap]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-ks-search-input]');
      var panel = wrap.querySelector('[data-ks-search-panel]');
      var results = wrap.querySelector('[data-ks-search-results]');
      var allLink = wrap.querySelector('[data-ks-search-all]');
      if (!input || !panel || !results) return;

      var timer = null;
      var ctrl = null;
      var lastQuery = '';

      function openPanel() { panel.removeAttribute('hidden'); }
      function closePanel() { panel.setAttribute('hidden', ''); }

      function formatPrice(p) {
        var price = String(p.price || '').replace('.', ',');
        var from = p.price_min && p.price_max && p.price_min !== p.price_max;
        return (from ? 'alk. ' : '') + price + ' €';
      }

      function imgUrl(p) {
        var u = (p.featured_image && p.featured_image.url) || p.image || '';
        if (!u) return '';
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      }

      function render(products, q) {
        if (!products.length) {
          results.innerHTML = '<div class="ks-search-empty">Ei tuloksia haulle ”' + esc(q) + '”</div>';
        } else {
          results.innerHTML = products.map(function (p) {
            var img = imgUrl(p);
            return '<a class="ks-search-item" href="' + esc(p.url) + '">' +
              '<span class="ks-search-item-img"' + (img ? ' style="background-image:url(\'' + img + '\')"' : '') + '></span>' +
              '<span class="ks-search-item-title">' + esc(p.title) + '</span>' +
              '<span class="ks-search-item-price">' + formatPrice(p) + '</span>' +
              '</a>';
          }).join('');
        }
        if (allLink) {
          allLink.href = '/search?q=' + encodeURIComponent(q);
          if (products.length) { allLink.removeAttribute('hidden'); } else { allLink.setAttribute('hidden', ''); }
        }
        openPanel();
      }

      function doSearch(q) {
        if (ctrl) ctrl.abort();
        ctrl = ('AbortController' in window) ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var products = (d.resources && d.resources.results && d.resources.results.products) || [];
            lastQuery = q;
            render(products, q);
          })
          .catch(function () { /* keskeytetty tai verkkovirhe — ei tehdä mitään */ });
      }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) {
          results.innerHTML = '';
          if (allLink) allLink.setAttribute('hidden', '');
          closePanel();
          return;
        }
        timer = setTimeout(function () { doSearch(q); }, 250);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.childNodes.length) openPanel();
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closePanel();
          input.blur();
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) closePanel();
      });
    });
  }

  /* ===========================================
     NAVBAR — mobiilivalikon avaus + korin proxy
     =========================================== */
  function initNavbarShell() {
    var overlay = document.querySelector('[data-ks-mobilemenu]');
    var openBtn = document.querySelector('[data-ks-mobile-open]');
    if (overlay && openBtn) {
      openBtn.addEventListener('click', function () {
        overlay.removeAttribute('hidden');
        document.documentElement.classList.add('ks-m-lock');
      });
      overlay.querySelectorAll('[data-ks-mobile-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          overlay.setAttribute('hidden', '');
          document.documentElement.classList.remove('ks-m-lock');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) {
          overlay.setAttribute('hidden', '');
          document.documentElement.classList.remove('ks-m-lock');
        }
      });
    }
    /* Kori: avaa teeman cart-drawer jos sen toggle löytyy piilotetusta headerista */
    document.querySelectorAll('[data-ks-cart]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var themeToggle = document.querySelector('.header__wrapper [data-drawer-toggle="drawer-cart"]');
        if (themeToggle) {
          e.preventDefault();
          themeToggle.click();
        }
      });
    });
  }

  function init() {
    initDesktop();
    initMobile();
    initSmallDrops();
    initSearch();
    initNavbarShell();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
